import mjlx from './meiju.json.js'

function meijuFrom (value, type){
  let list = mjlx[type];
  for(let i in list){
    if(value == list[i].code){
      return list[i].name;
    }
  }
}

function meijuFromkey(value, type){
    debugger;
    let list = mjlx[type];
    debugger;
    for(let i in list){
        if(value == list[i].bankomCode){
            return list[i].code_1;
        }
    }
}

export {
    meijuFrom,
    meijuFromkey
}



// WEBPACK FOOTER //
// ./src/static/js/meijuForm.js